import { AppConstants } from '@/app.constants';
import { idbStorage } from './idbStorage';


export const OpenedInspectionStorage = {
  getItem: async (key: string): Promise<string | null> => {
    return (await idbStorage.getItem(AppConstants.INDEX_DB.store.openedInspection, key)) || null;
  },

  setItem: async (key: string, value: string): Promise<void> => {
    await idbStorage.setItem(AppConstants.INDEX_DB.store.openedInspection, key, value);

  },

  removeItem: async (key: string): Promise<void> => {
    await idbStorage.removeItem(AppConstants.INDEX_DB.store.openedInspection, key);
  },
};
